/**
 * Date Picker for IronHUD (Alpine.js Component)
 */

export const DatePickerComponent = (config = {}) => ({
    instance: null,
    date: config.initialDate || new Date().toISOString().split('T')[0],
    displayMonth: '',
    displayDay: '',
    displayFull: '',
    months: [],

    init() {
        const lang = document.documentElement.lang || 'pt-BR';
        const isPt = lang.startsWith('pt');
        this.months = isPt
            ? ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
            : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        // Initial display update
        const initialDate = new Date(this.date + 'T12:00:00'); // Use noon to avoid TZ issues
        this.updateDisplay(initialDate);
    },

    // Initialize Flatpickr on a specific element
    setup(el) {
        const lang = document.documentElement.lang || 'pt-BR';
        const isPt = lang.startsWith('pt');

        this.instance = flatpickr(el, {
            disableMobile: true,
            locale: isPt ? 'pt' : 'en',
            defaultDate: this.date,
            onChange: (selectedDates, dateStr) => {
                const date = selectedDates[0];
                if (!date) return;

                this.date = dateStr;
                this.updateDisplay(date);

                // Dispatch event for other components to react if needed
                this.$dispatch('date-changed', { date: dateStr, dateObj: date });
            },
            ...config.flatpickr,
        });
    },

    updateDisplay(date) {
        if (!this.months.length) return;
        this.displayMonth = this.months[date.getMonth()];
        this.displayDay = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        this.displayFull = `${this.displayDay} ${this.displayMonth}, ${year}`;
    },

    destroy() {
        if (this.instance) this.instance.destroy();
    },
});
